<template>
  <div class="searcher">

    <input 
    type="search" 
    id="destinationCity" 
    list="destinationCityList" 
    placeholder="Название или ИНН" 
    v-model="searchQuery"
    @input="search"
    @keydown.enter="resetSearch"
    >
    <div class="item-list">
      <ul v-if="showSuggestions && searchQuery" class="suggestions">
        <li v-for="company in filteredItems" :key="company.id" @click="selectCompany(company)">{{ company.name }}</li>
      </ul>
    </div>

  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';

export default {
  name: 'reactiv-search',
  props:['items','model'],
  setup(props, { emit }) {
    const searchQuery = ref('');
    const selectedItem = ref(null);

    const showSuggestions = ref(false);

    const filteredItems = computed(() => {
      if (searchQuery.value) {
        return props.items.filter((company) => {
          const query = searchQuery.value.toLowerCase();
          return company.name.toLowerCase().includes(query) || company.inn.includes(query);
        });
      }
      return [];
    });

    const search = () => {
      showSuggestions.value = true;
    };

    const resetSearch = () =>{
      if( searchQuery.value === ''){
        emit('resetSearch');
      }
    }

    const selectCompany = (company) => {
      selectedItem.value = company;
      showSuggestions.value = false;
      searchQuery.value = company.name;
      emit('changeItem', company);
    };

    const show = computed(()=>{
      if(!searchQuery.value){
        showSuggestions.value = false
      }
    })

    watch(() => props.model, (newModel) => {
      selectedItem.value = newModel;
      searchQuery.value = newModel ? newModel.name : '';
    });

    watch(searchQuery, () => {
      if (searchQuery.value === '') {
        showSuggestions.value = false;
      }
    });

    return {
      resetSearch,
      searchQuery,
      selectedItem,
      showSuggestions,
      filteredItems,
      search,
      selectCompany,
    };
  },
};
</script>


<style scoped>

.searcher {
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.searcher input {
  padding: 3px;
  width: 400px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.item-list{
  position: relative;
  font-size: 12px;
}

.suggestions {
  width: 400px;
  border-radius: 5px;
  padding: 5px;
  background-color: white;
  border: 1px solid #ccc;
  position: absolute;
  list-style: none;
  margin: auto;
  text-align: left;
  overflow: auto;
  max-height: 200px;
}

.suggestions li {
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}

.suggestions li:hover {
  background-color: #f0f0f0;
}
</style>
